<template>
  <div
    :id="data.id"
    class="bg-gray-lighten3 pb-[5.25rem] pt-[5rem] md:pb-[7.25rem] md:pt-28"
  >
    <div class="container overflow-hidden text-slate">
      <UiSectionTitle
        v-if="data.title"
        :title="data.title"
        class="title mb-6 flex text-3xl uppercase leading-[1em] md:justify-center md:whitespace-pre-line md:text-center md:text-[3.5rem]"
      />

      <div
        v-if="data.text"
        class="mb-8 flex font-segoe text-md leading-[1.813rem] md:mb-12 md:justify-center md:text-center"
      >
        <span class="md:whitespace-pre-line" v-html="data.text" />
      </div>

      <div v-if="data.items && data.items.length">
        <swiper-container
          ref="swiperEl"
          init="false"
          class="md:pb-15 pb-9"
          :class="{ '!overflow-visible': !isDesktop }"
        >
          <swiper-slide
            v-for="(item, i) in data.items"
            :key="i"
            class="w-full md:w-[777px]"
          >
            <div
              v-lazy-background="getAssetUrl(item.image)"
              class="mb-6 h-[220px] overflow-hidden rounded-lg bg-cover bg-center font-bold md:mb-8 md:h-[520px]"
            ></div>

            <div class="flex flex-col">
              <div
                v-if="item.title"
                class="title mb-4 text-xl uppercase leading-none md:text-3xl"
                v-html="item.title"
              />
              <div
                v-if="item.text"
                class="text-uppercase font-segoe text-md leading-[1.813rem] md:max-w-[566px]"
                v-html="item.text"
              />

              <UiButton
                v-if="item.button && item.button.link"
                :to="item.button.link"
                :target="item.button.target"
                size="md"
                class="mb-4 mt-2"
              >
                <span v-html="item.button.text" />
              </UiButton>
            </div>
          </swiper-slide>

          <div slot="container-end" class="swiper-scrollbar"></div>
        </swiper-container>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBreakpoint, useMediaAsset, useSwiperElement } from '~/composables';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const { getAssetUrl } = useMediaAsset();

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

const swiperEl = useSwiperElement(swiperOptions);
</script>
